// Stejný vzorec jako na serveru a v administraci, aby se částka shodovala
// s tím, co se skutečně pošle do platební brány.
export function applyRentalDiscount(rental: number, percent: number) {
  return Math.round((rental / 100) * (100 - percent));
}

export function getRentalDiscountAmount(rental: number, percent: number) {
  return rental - applyRentalDiscount(rental, percent);
}

// Tržba a daň pro GTM. `price` je hrubá cena objednávky (u dopravy včetně
// dopravy), sleva z kódu se počítá jen z půjčovného. Bez slevy vychází
// stejné hodnoty jako dřív.
export function getPurchaseRevenue(price: number, shipping: number, discountPercent: number) {
  const rental = price - shipping;
  const revenue = discountPercent > 0 ? applyRentalDiscount(rental, discountPercent) : rental;
  const total = revenue + shipping;
  return { revenue, tax: Math.ceil((total - total / 1.21) * 100) / 100 };
}
